export const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
export const coDay = (d = new Date()) => d.toLocaleDateString('en-CA', { timeZone: 'America/Bogota' });
export const pd = (s) => { const [a, b, c] = s.split('-').map(Number); return new Date(a, b - 1, c); };
export const fd = (d) => d.toLocaleDateString('es-CO', { weekday: 'short', day: 'numeric', month: 'short' });

const festCache = {};
export const festivos = (y) => {
  if (festCache[y]) return festCache[y];
  const f = new Set();
  const add = (m, d) => f.add(iso(new Date(y, m - 1, d)));
  const mon = (m, d) => { const t = new Date(y, m - 1, d); t.setDate(t.getDate() + ((8 - t.getDay()) % 7)); f.add(iso(t)); };
  [[1, 1], [5, 1], [7, 20], [8, 7], [12, 8], [12, 25]].forEach((x) => add(...x));
  [[1, 6], [3, 19], [6, 29], [8, 15], [10, 12], [11, 1], [11, 11]].forEach((x) => mon(...x));
  const a = y % 19, b = Math.floor(y / 100), cc = y % 100, d = Math.floor(b / 4), e = b % 4;
  const g = Math.floor((8 * b + 13) / 25), q = (19 * a + b - d - g + 15) % 30, i = Math.floor(cc / 4), k = cc % 4;
  const l = (32 + 2 * e + 2 * i - q - k) % 7, m = Math.floor((a + 11 * q + 22 * l) / 451);
  const mo = Math.floor((q + l - 7 * m + 114) / 31), da = ((q + l - 7 * m + 114) % 31) + 1;
  const E = new Date(y, mo - 1, da);
  [-3, -2, 43, 64, 71].forEach((n) => { const t = new Date(E); t.setDate(t.getDate() + n); f.add(iso(t)); });
  festCache[y] = f;
  return f;
};

export const isBD = (d) => { const w = d.getDay(); return w > 0 && w < 6 && !festivos(d.getFullYear()).has(iso(d)); };
export const addBD = (d, n) => { const t = new Date(d); let k = n; while (k > 0) { t.setDate(t.getDate() + 1); if (isBD(t)) k--; } return t; };
export const bdiff = (a, b) => { const t = new Date(a); let n = 0; while (iso(t) < iso(b)) { t.setDate(t.getDate() + 1); if (isBD(t)) n++; } return n; };
const prevBD = (d) => { const t = new Date(d); do { t.setDate(t.getDate() - 1); } while (!isBD(t)); return t; };

const CO = [['Toma de medidas', 1], ['Entrega del render', 2], ['Corte y enchape', 3], ['Recepción de material', 1], ['Armado de muebles', 4, 1], ['Entrega', 1]];
export const DEF_PARAMS = {
  bano: { n: 'Muebles de baño', lim: 8, u: 'unidades', s: [['Corte y enchape', 3], ['Recepción de material', 1], ['Armado de muebles', 6, 1], ['Entrega', 1]] },
  cocina: { n: 'Cocina integral', lim: 15, u: 'm²', s: CO },
  proy: { n: 'Proyecto completo', lim: 30, u: 'm²', s: CO },
  puer: { n: 'Puertas', lim: 8, u: 'puertas', s: [['Toma de medidas', 1], ['Corte y madera', 1], ['Armado y pegado', 5, 3], ['Corte y enchape', 3], ['Entrega e instalación', 1]] },
};

const stepDays = (s, q) => (s.length === 3 ? Math.max(1, Math.ceil((q || 1) / s[1])) * s[2] : s[1]);

// Plan programado (desde el abono) + proyección real (pasos pendientes no pueden empezar antes de hoy)
export function plan(o, P, today) {
  const p = P[o.tipo] || Object.values(P)[0];
  const floor = prevBD(pd(today));
  const createdDay = o.createdAt ? coDay(new Date(o.createdAt)) : null;
  let cur = pd(o.fechaAbono);
  let proj = pd(o.fechaAbono);
  const rows = p.s.map((s, i) => {
    const days = stepDays(s, o.cantidad);
    const st = addBD(cur, 1), en = addBD(cur, days);
    // Pasos marcados el día que se registró el pedido cuentan en su fecha programada
    const raw = o.done?.[i];
    const dn = raw && raw === createdDay && iso(en) < raw ? iso(en) : raw;
    if (!dn && iso(proj) < iso(floor)) proj = floor;
    proj = dn ? pd(dn) : addBD(proj, days);
    cur = dn ? pd(dn) : en;
    const state = dn ? 'done' : iso(en) < today ? 'late' : iso(st) <= today ? 'now' : 'next';
    return { i, n: s[0], days, st, en, dn, state };
  });
  const dead = addBD(pd(o.fechaAbono), p.lim);
  const finished = rows.every((r) => r.dn);
  const margin = iso(proj) <= iso(dead) ? bdiff(proj, dead) : -bdiff(dead, proj);
  const overdueStep = rows.some((r) => r.state === 'late');
  let status = 'espacio';
  if (finished) status = 'done';
  else if (margin < 0 || overdueStep) status = 'late';
  else if (margin <= 2) status = 'justo';
  return { rows, dead, fc: proj, margin, status, finished, done: rows.filter((r) => r.dn).length, type: p };
}

export const STATUS = {
  late: { label: 'Atrasado', dot: 'bg-red-500', badge: 'bg-red-50 text-red-700 border-red-200', ring: 'border-l-red-500', chip: 'bg-red-100 text-red-800 border-red-200', bar: 'bg-red-500' },
  justo: { label: 'Justo', dot: 'bg-amber-500', badge: 'bg-amber-50 text-amber-700 border-amber-200', ring: 'border-l-amber-500', chip: 'bg-amber-100 text-amber-800 border-amber-200', bar: 'bg-amber-500' },
  espacio: { label: 'Con espacio', dot: 'bg-emerald-500', badge: 'bg-emerald-50 text-emerald-700 border-emerald-200', ring: 'border-l-emerald-500', chip: 'bg-emerald-100 text-emerald-800 border-emerald-200', bar: 'bg-emerald-500' },
  done: { label: 'Terminado', dot: 'bg-blue-600', badge: 'bg-blue-50 text-blue-700 border-blue-200', ring: 'border-l-blue-600', chip: 'bg-blue-100 text-blue-800 border-blue-200', bar: 'bg-blue-600' },
};

export const marginText = (pl) => {
  if (pl.finished) return 'Terminado';
  if (pl.margin < 0) return `${-pl.margin} día${pl.margin === -1 ? '' : 's'} de retraso`;
  if (pl.status === 'late') return 'Paso vencido';
  return `+${pl.margin} día${pl.margin === 1 ? '' : 's'} de margen`;
};

export const cap = (t) => t.charAt(0).toUpperCase() + t.slice(1);
export const shortName = (n) => n.split(' ').slice(0, 2).join(' ');
